export default {
  landscape: 'Landscape',
  portrait: 'Portrait',
};
